<template>
  <div
    id="columns_sidebar_hedaer"
    :class="$.header"
  >
    <div
      :class="$.top"
      :style="styles"
    >
      <div :style="{marginRight: '4px'}">
        <icon-button
          v-if="backButton"
          id="gp_autotest_columns_bar_button_back"
          :icon="{ name:'arrow-left' }"
          size="small"
          @onClick="$emit('backClick')"
        />
      </div>
      <div :class="$.title">
        {{ title }}
      </div>
      <div :class="$.top__right">
        <icon-button
          v-if="helpButton"
          id="gp_autotest_columns_bar_help"
          :icon="{ name:'help'}"
          size="small"
          :style="{color: helpIconColor }"
          @onClick="helpIconClick($event)"
        />

        <icon-button
          id="gp_autotest_columns_bar_close"
          :icon="{ name:'close-1' }"
          size="small"
          @onClick="onClose"
        />
      </div>
    </div>
    <vgp-tabs
      v-if="tabs.length"
      :tabs="tabs"
      active-by="type"
      :active="activeTab"
      :small="true"
      :type="'tab'"
      :styles="{ paddingLeft: '12px'}"
      gp-autotest-name="gp_autotest_columns_bar_tabs"
      @onToggle="onChangeTab"
    />
  </div>
</template>

<script>
import iconButton from '../../../../common/VueComponents/globalButton/withIcon/iconButton.vue';
import vgpTabs from '../../../../common/VueComponents/tabs/vgpTabs.vue';

export default {
  name: 'ColumnsBarHeader',
  components: { iconButton, vgpTabs },
  props: {
    title: { type: String, required: true, default: '' },
    viewConfig: { type: Object, required: false, default: () => {} },
    tabs: { type: Array, default: () => [] },
    backButton: { type: Boolean, required: false, default: true },
    helpButton: { type: Boolean, required: false, default: true },
  },
  emits: {
    backClick: null,
    onChangeTab: Object,
    helpIconClick: Object,
    onClose: null,
  },
  data() {
    return {
      activeTab: null,
    };
  },
  computed: {
    styles() {
      let styles = {};

      if (!this.tabs.length) {
        styles = { 'padding-bottom': '36px' };
      }

      return styles;
    },
    helpIconColor() {
      const activityStatus = this.$store.getters['user/getActivityStatus']('customGridHelpBlock');

      if (activityStatus) {
        return '#808080';
      }

      return '#E65100';
    },
  },
  watch: {
    viewConfig: {
      handler() {
        this.activeTab = this.tabs.find(tab => tab.type === this.viewConfig.activeTab);
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    onChangeTab(obj) {
      this.activeTab = obj;
      this.$emit('onChangeTab', obj);
    },
    onClose() {
      this.activeTab = null;
      this.$emit('onClose');
    },
    helpIconClick(e) {
      this.$emit('helpIconClick', e);
    },
  },
};
</script>

<style module='$' src='./header.less' lang='less'></style>
